import React from 'react';
import PropTypes from 'prop-types';
import '../assignments.scss';
import Modal from '../../../components/Modal';
import {useGetPreviewAssignmentInfoMutation} from '../../../features/authentication/assignmentApislice';
import { useGetQuestionByIdMutation } from '../../../features/authentication/assignApiSlice';
import { useAssignmentContext } from '../context';
import QuestionDetail from './QuestionDetail';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';
import AssignmentPreviewHeader from './AssignmentPreviewHeader';
import QuestionPreviewTypes from '../../../enums/questionPreviewTypes';
import { DateFormatter } from '../../../utils/DateFormatter';

const AssignmentPreviewModal = ({
  isOpen,
  onClose
}) => {
  const Ids = useParams();
  const assignment = useAssignmentContext();
  const Id = assignment?.assignmentId
    ? assignment?.assignmentId
    : Ids.Id
      ? Ids.Id
      : Ids.assignmentId;

  const [selectedQuestionIndex, setSelectedQuestionIndex] = React.useState(0);
  const [getPreviewAssignmentInfo] = useGetPreviewAssignmentInfoMutation();
  const [getQuestionDetailsById] = useGetQuestionByIdMutation();
  const [questions, setQuestions] = React.useState({});
  const [questionDetails, setQuestionDetails] = React.useState({});
  const [currentPage, setCurrentPage] = React.useState(0);
  const [qSetChange, setQSetChange] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [setHtmlContentUrl] = React.useState('');
  const PAGE_SIZE  = 24;
  const questionCount = questions?.questionIds?.length;
  const numPages = Math.ceil(questionCount / PAGE_SIZE);
  const startIndex = currentPage * PAGE_SIZE;
  const endIndex = startIndex + PAGE_SIZE;
  const pageQuestionIds = questions?.questionIds?.slice(startIndex, endIndex);

  React.useEffect(() => {
    if (isOpen) {
      getPreviewDetails();
    }
  }, [isOpen]);

  async function getPreviewDetails()
  {
    const option = { assignmentId: Id };
    const response = await getPreviewAssignmentInfo(option).unwrap();
    setQuestions(response);
    getQuestionDetailsByIdHandler(response.questionIds[0],0);
  }

  React.useEffect(() => {
    if(questions?.questionIds?.length>0 && startIndex < questions?.questionIds?.length)
    {
      getQuestionDetailsByIdHandler(questions.questionIds[startIndex],startIndex);
    }
  }, [qSetChange]);

  const getQuestionDetailsByIdHandler = async (questionId, index) => {
    if(!questionId)
      return;

    setIsLoading(true);
    setSelectedQuestionIndex(index);
    let option = { assignmentId: Id, questionId: questionId, languageId: 0 };
    try {
      const response = await getQuestionDetailsById(option).unwrap();
      setQuestionDetails(response);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
    setIsLoading(false);
  };

  function handlePrevPage() {
    setCurrentPage(currentPage - 1);
    setQSetChange(!qSetChange);
  }

  function handleNextPage() {
    setCurrentPage(currentPage + 1);
    setQSetChange(!qSetChange);
  }

  const nextQuestionHandler = () => {
    const modalContentEl = document.querySelector('.modal-details');
    const firstQuestionEl = modalContentEl.querySelector('p');
    firstQuestionEl.scrollIntoView({ behavior: 'smooth', top: '0' });

    if (selectedQuestionIndex < questions?.questionIds?.length - 1) {
      
      getQuestionDetailsByIdHandler(questions?.questionIds[selectedQuestionIndex + 1], selectedQuestionIndex + 1);
    }
    if (endIndex === selectedQuestionIndex + 1) setCurrentPage(currentPage + 1);
  };

  const resetCurrentPage = () => {
    setCurrentPage(0);
  };
   
  return (
    <Modal
      isOpen={isOpen}
      titleName={'Assignment Preview'}
      onClose={() => {
        onClose();
        resetCurrentPage();
      }}
      contentWidth="100%">
      <>
        <AssignmentPreviewHeader
          assignmentName = {questions?.assignmentName}
          numberOfQuestions={`${selectedQuestionIndex + 1}/${questions?.questionIds?.length ? questions?.questionIds?.length : ''}`}
          courseName={questions?.courseName}
          verificationNumber={questions?.verificationNummber}
          type={QuestionPreviewTypes.assignmentPreview}
          createdDate ={questions?.createdDate !== undefined ? DateFormatter.toShortDate(questions?.createdDate) : ''}
        />
        <div className="assignment-review-content d-flex align-items-start  mb-2">
          <div className="questions-numbers flex-shrink-0">
            <div className="d-flex justify-content-between">
              <h4 style={{ paddingTop: '10px' }}>Questions</h4>
              {numPages > 1 && (
                <>
                  <ul className="flex-row gap-2" style={{ display: 'flex' }}>
                    <li style={{ background: '#FFF6EC' }} className='question-list-item'>
                      <a
                        href="#"
                        onClick={handlePrevPage}
                        style={{ border: 'none' }}
                        className={`btn btn-castleOrangeLite ${currentPage === 0 && 'disabled'
                        }`}>
                        <FontAwesomeIcon icon={faChevronLeft} />
                      </a>
                    </li>
                    <li style={{ background: '#FFF6EC' }} className='question-list-item'>
                      <a
                        href="#"
                        onClick={handleNextPage}
                        style={{ border: 'none' }}
                        className={`btn btn-castleOrangeLite ${currentPage === numPages - 1 && 'disabled'
                        }`}>
                        <FontAwesomeIcon icon={faChevronRight} />
                      </a>
                    </li>
                  </ul>
                </>
              )}
            </div>
            <ul className="d-flex flex-wrap m-0 p-0 gap-2">
              {pageQuestionIds?.map((questionId, index) => {
                const questionIndex = startIndex + index;
                return (
                  <li
                    style={{ cursor: 'pointer' }}
                    key={questionIndex}
                    onClick={() => getQuestionDetailsByIdHandler(questionId,questionIndex)}
                    className={`${selectedQuestionIndex == questionIndex && 'active'} question-list-item`}>
                    <a>{questionIndex + 1}</a>
                  </li>
                );
              })}
            </ul>
          </div>
          <QuestionDetail
            questionDetails={questionDetails}
            nextQuestionHandler={nextQuestionHandler}
            selectedQuestionId={selectedQuestionIndex}
            lastQuestion={questionCount === selectedQuestionIndex + 1 ? true : false}
            isLoading={isLoading}
            setHtmlContentUrl={setHtmlContentUrl}
            assignmentId={Id}
            type={QuestionPreviewTypes.assignmentPreview}
            assignmentDetails={questions}
          />
        </div>
      </>
    </Modal>      
  );
};

AssignmentPreviewModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default AssignmentPreviewModal;
